// FOR FUTURE REFACTORING.. THIS IS THE SAME FUNCTION AS THE ONE INSIDE CUSTOMCREATEPOST COMPONENT

export const uploadMedia = async (
  mediaUploads: { file: File; type: string }[],
  fileType: string,
): Promise<
  {
    mediaUrl: string
    mediaPublicId: string
    type: string
  }[]
> => {
  try {
    if (
      !import.meta.env.VITE_MEDIA_API_URL ||
      !import.meta.env.VITE_SERVER_API_URL
    ) {
      throw new Error('Something went wrong.. please try again later.')
    }

    let uploadData: {
      mediaUrl: string
      mediaPublicId: string
      type: string
    }[] = []

    const signRes = await fetch(
      import.meta.env.VITE_SERVER_API_URL + '/api/v1/post/getMediaUploadSign',
      {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      },
    )

    if (!signRes.ok) {
      throw new Error('Something went wrong.. please try again later.')
    }

    const signData = await signRes.json()

    const urlParts: string[] = import.meta.env.VITE_MEDIA_API_URL.split('$')
    const url = urlParts[0] + signData.cloudname + '/' + fileType + urlParts[1]

    for (let i = 0; i < mediaUploads.length; i++) {
      const formData = new FormData()

      formData.append('file', mediaUploads[i].file)
      formData.append('api_key', signData.apiKey)
      formData.append('timestamp', signData.timestamp)
      formData.append('signature', signData.signature)
      formData.append('folder', signData.folder)

      const res = await fetch(url, {
        method: 'POST',
        body: formData,
      })

      if (!res.ok) {
        throw new Error(`Upload failed: ${res.statusText}`)
      }

      const data = await res.json()
      uploadData.push({
        mediaUrl: data.secure_url,
        mediaPublicId: data.public_id,
        type: mediaUploads[i].type,
      })
    }
    return uploadData
  } catch (err) {
    throw new Error(err)
  }
}
